// extracted by mini-css-extract-plugin
export default {"imageContainer":"u1-z","summaryPar":"v1-z","ratingCategories":"w1-z","reviewerInfo":"x1-z","reviewTypes":"y1-z","expanded":"z1-z"};